import styled from "styled-components";
export * from "./Button";
export * from "./Field";
export * from "./FieldAddress";
// export * from "./FieldBuilder";
export * from "./FieldCheckbox";
export * from "./FieldCustomer";
export * from "./FieldCustomers";
export * from "./FieldCustomerShippingAddress";
export * from "./FieldDatepicker";
export * from "./FieldDebounce";
export * from "./FieldDeliveryRun";
export * from "./FieldDepartmentPicker";
export * from "./FieldDiscountType";
export * from "./FieldDock";
export * from "./FieldDriver";
export * from "./FieldDriverImage";
export * from "./FieldEditor";
export * from "./FieldFleetVendor";
// export * from "./FieldFormula";
export * from "./FieldImage";
export * from "./FieldInsertIssue";
export * from "./FieldInsertProducts";
export * from "./FieldInsertServiceReminder";
export * from "./FieldInsertVehicle";
export * from "./FieldModifyProduct";
export * from "./FieldOrderProducts";
export * from "./FieldPassword";
export * from "./FieldPlaces";
export * from "./FieldPriceCategoryCalculator";
export * from "./FieldPriceLevelCalculator";
export * from "./FieldPricing";
export * from "./FieldPricingMethod";
export * from "./FieldServiceReminders";
export * from "./FieldServiceTask";
export * from "./FieldSpecialPriceCalculator";
export * from "./FieldState";
export * from "./FieldStructureCustomers";
export * from "./FieldTableProducts";
export * from "./FieldTableVehicles";
export * from "./FieldTableWarehousePickers";
export * from "./FieldUploader";
export * from "./FieldUser";
export * from "./FieldUsers";
export * from "./FieldVehicle";
export * from "./FieldVehicleExpenseType";
export * from "./FieldVehicles";
export * from "./FieldVehicleStatus";
export * from "./FieldVehicleType";
export * from "./FilePreview";
export * from "./Response";

export const selectStyles = {
  menu: (base: any, state: any) => ({
    ...base,
    padding: 5,
    borderRadius: "0.375rem",
  }),
  multiValue: (base: any, state: any) => {
    return state.data.isFixed
      ? { ...base, backgroundColor: "gray", color: "#ffffff" }
      : {
          ...base,
          backgroundColor: "#68CB6D",
          color: "#ffffff",
        };
  },
  multiValueLabel: (base: any, state: any) => {
    return state.data.isFixed
      ? { ...base, fontWeight: "bold", color: "#ffffff", paddingRight: 6 }
      : { ...base, color: "#ffffff" };
  },
  multiValueRemove: (base: any, state: any) => {
    return state.data.isFixed
      ? { ...base, display: "none", color: "#ffffff" }
      : {
          ...base,
          color: "#ffffff",
          ":hover": {
            backgroundColor: "#ff1100",
            color: "#ffffff",
          },
        };
  },
  option: (base: any, state: any) => ({
    ...base,
    margin: "5px 0",
    paddingTop: "10px",
    paddingBottom: "10px",
    borderRadius: "0.375rem",
    backgroundColor: state.isDisabled
      ? "#f7f7f7"
      : state.isSelected
      ? "#e5ece4"
      : "#ffffff",
    color: state.isDisabled
      ? "#808080"
      : state.isSelected
      ? "#329137"
      : "#374151",

    ":hover": {
      backgroundColor: state.isDisabled ? "#f7f7f7" : "#e5ece4",
      color: state.isDisabled ? "#808080" : "#329137",
    },
  }),
};

export const SelectWrapper = styled.div`
  position: relative;

  div > div[id*="react-select-"]:last-child {
    z-index: 11;
  }

  & > div > div:nth-child(3) {
    padding-top: 2px;
    padding-bottom: 2px;
    min-height: 1rem;
    height: 100%;
    border: 0;
    outline: 0;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
  }
  & > div input,
  & > div input:focus,
  & > div input:hover,
  & > div input:active {
    border: 0;
    outline: 0;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const COUNTRIES = [
  {
    label: "New South Wales",
    value: "NSW",
  },
  {
    label: "Victoria",
    value: "VIC",
  },
  {
    label: "Queensland",
    value: "QLD",
  },
  {
    label: "Tasmania",
    value: "TAS",
  },
  {
    label: "South Australia",
    value: "SA",
  },
  {
    label: "Western Australia",
    value: "WA",
  },
  {
    label: "Northern Territory",
    value: "NT",
  },
  {
    label: "Australian Capital Territory",
    value: "ACT",
  },
];
